import { ref, watch } from 'vue';

// The mobile runtime moves Concluídos before the virtualizer inside the
// scroller. Virtua needs that leading space to calculate the visible rows.
export function useConversationListStartMargin(scrollRef, virtualListRef) {
  const startMargin = ref(0);

  watch(
    [scrollRef, virtualListRef],
    ([scroller, virtualList], _, onCleanup) => {
      startMargin.value = 0;
      const content = virtualList?.$el;
      if (!scroller || content?.nodeType !== 1) return;

      const mobile = window.matchMedia('(max-width: 767px)');
      const measure = () => {
        startMargin.value = mobile.matches
          ? Math.max(
              0,
              content.getBoundingClientRect().top -
                scroller.getBoundingClientRect().top +
                scroller.scrollTop -
                scroller.clientTop
            )
          : 0;
      };
      const resizeObserver = new ResizeObserver(measure);
      let mutationObserver;
      const observeLeadingContent = () => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
        resizeObserver.observe(scroller);
        mutationObserver.observe(scroller, { childList: true });
        for (const child of scroller.children) {
          if (child === content) break;
          resizeObserver.observe(child);
          mutationObserver.observe(child, {
            attributes: true,
            attributeFilter: ['style', 'class'],
          });
        }
        measure();
      };
      mutationObserver = new MutationObserver(observeLeadingContent);

      mobile.addEventListener('change', measure);
      observeLeadingContent();
      onCleanup(() => {
        resizeObserver.disconnect();
        mutationObserver.disconnect();
        mobile.removeEventListener('change', measure);
      });
    },
    { flush: 'post' }
  );

  return startMargin;
}
